import { Box, Button, Divider, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { LeftBar, TopBarContainer, SecondRow, RightBar, WelcomeBox, FirstRow } from './sx';
import { useAppSelector } from '../../../reducer/hooks';
import { selectProfile } from '../../../reducer/profileSlice';
import { useTranslation } from '../../../hooks';
import { enumMapping } from '../../../utils';
import { enumTimezone } from '../../../utils/constant';
import { selectIsMobileView } from '../../../reducer/mediaSlice';
import { LanguageSelection } from '../../../views/User/AccountSetting';
import { OpIconButtonAdjustable } from '../../Button';
import LogoutButton from '../../Button/LogoutButton';
import { OpSettingComponent } from '../../../assets/icons';
import { useNavigate } from 'react-router-dom';
import { Dispatch, SetStateAction } from 'react';
import { selectStuff } from '../../../reducer/stuffSlice';

const Enum = {
  timezones: enumMapping(enumTimezone),
};

type ITopBar = {
  isShowSideMenuInMobileView: boolean;
  setIsShowSideMenuInMobileView: Dispatch<SetStateAction<boolean>>;
  setIsSideMenuCollapse: Dispatch<SetStateAction<boolean>>;
};

const TopBar = (props: ITopBar) => {
  const { isShowSideMenuInMobileView, setIsShowSideMenuInMobileView, setIsSideMenuCollapse } =
    props;
  const { t, te, tc } = useTranslation('menu');
  const { email, timezone } = useAppSelector(selectProfile);
  const isMobileView = useAppSelector(selectIsMobileView);
  const { viewTitle } = useAppSelector(selectStuff);
  const timezoneDisplay = `GMT${te(Enum.timezones[timezone])}`;
  const redirect = useNavigate();

  const profile = useAppSelector(selectProfile);

  return (
    <TopBarContainer>
      {/* <div style={{ padding: '12px 0', fontSize: '14px', fontWeight: 'bold' }}>
        {profile.appName}
      </div> */}
      <FirstRow isMobileView={isMobileView}>
        <LeftBar>
          {/* side menu icon for mobile */}
          {isMobileView && (
            <MenuIcon
              sx={{ marginRight: '12px' }}
              onClick={() => {
                setIsShowSideMenuInMobileView(!isShowSideMenuInMobileView);
                setIsSideMenuCollapse(false);
              }}
            />
          )}
          <Box>
            <WelcomeBox>
              {/* welcome, (email) */}
              <Typography
                variant="h5"
                fontWeight={700}
                sx={(theme) => ({
                  color: theme.palette.text.secondary,
                })}
              >
                {tc('welcome')},
              </Typography>
              <Typography variant="h5" maxWidth={250} textOverflow={'ellipsis'} noWrap>
                {email}
              </Typography>
            </WelcomeBox>

            {/* Reserved for future use */}
            {/* <Typography variant="h5">{`${tc('merchantId')}: ${'PA-123456'}`}</Typography> */}
          </Box>
        </LeftBar>

        <RightBar>
          {!isMobileView && (
            <>
              {/* <LanguageSelection /> */}
              {/* timezone */}
              <Button
                variant="outlined"
                sx={{ height: '24px' }}
                onClick={() => redirect('/accountSetting')}
              >
                <Typography>{timezoneDisplay}</Typography>
              </Button>
            </>
          )}

          {/* Gear Icon */}
          <OpIconButtonAdjustable
            title={t('accountSetting')}
            size={'1rem'}
            SvgElement={OpSettingComponent}
            onClick={() => redirect('/accountSetting')}
          />

          {/* Logout button */}
          <LogoutButton isTopBar isHide={isMobileView} />
        </RightBar>
      </FirstRow>

      <Divider />

      <SecondRow isMobileView={isMobileView}>
        <Typography variant="h4">{viewTitle}</Typography>
      </SecondRow>
    </TopBarContainer>
  );
};
export default TopBar;
